"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoveEvents = void 0;
var LoveEvents;
(function (LoveEvents) {
    LoveEvents["ConnectedToRoom"] = "love.ConnectedToRoom";
    LoveEvents["DisconnectedFromRoom"] = "love.DisconnectedFromRoom";
})(LoveEvents || (exports.LoveEvents = LoveEvents = {}));
//# sourceMappingURL=analytics.js.map